import React from 'react';
import logo from './../../media/logo.png';
import './Header.css';
import AppBar from 'material-ui/AppBar';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import NavigationMenu from 'material-ui/svg-icons/navigation/menu';
import MenuItem from 'material-ui/MenuItem';
import { Link } from 'react-router-dom';

class Header extends React.Component {
  render = () => {
    return(
      <AppBar
        showMenuIconButton={this.props.isMerchant(this.props.location) ? true : false}
        iconElementLeft={
          <IconButton 
            onTouchTap={this.props.toggleMenu}
            iconStyle={{color: 'grey', fill: 'grey'}}>
            <NavigationMenu />
          </IconButton>
        }
        style={{
          backgroundColor: '#ffffff',
        }}
        iconElementRight={this.props.isAuthenticated() ? <Logged logout={this.props.logout}/> : <div />}
        title={<Logo />}
      />
    );
  }
}

const Logo = props => (
  <div className="app-logo">
    <Link to="/"><img src={logo} className="logo" alt="logo" /></Link>
  </div> 
);

const Logged = ({logout, ...rest}) => (
  <IconMenu
    {...rest}
    iconButtonElement={
      <IconButton><MoreVertIcon /></IconButton>
    }
    targetOrigin={{horizontal: 'right', vertical: 'top'}}
    anchorOrigin={{horizontal: 'right', vertical: 'top'}}
  >
    <MenuItem primaryText="Sign out" onTouchTap={logout}/>
  </IconMenu>
);

export default Header



// WEBPACK FOOTER //
// ./src/components/header/Header.js